import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { RadioSelect } from "app/pages/sales-intelligence/common-components/form-fields";

export const StyledRadioSelector = styled(RadioSelect)`
    display: flex;
    flex-direction: column;
    padding: 12px 16px;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    gap: 8px;
`;
